import React from 'react';
import PropTypes from 'prop-types';
import { TOUCH } from '@/core/platform/platformStandards';
import { Box, Container, Paper, Button } from '@mui/material';
import { CheckCircleOutline as CheckCircleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import PendingApprovalPresentation from '@/features/auth/components/PendingApprovalPresentation';

const audienceFromUser = (userData) => {
  const r = (userData?.role || '').toLowerCase();
  if (r === 'investor') return 'investor';
  if (r === 'manager') return 'manager';
  return 'generic';
};

const RegistrationPendingApproval = ({ userData }) => {
  const navigate = useNavigate();
  const firstName = userData?.firstName ?? userData?.first_name ?? '';
  const lastName = userData?.lastName ?? userData?.last_name ?? '';
  const userName = `${firstName} ${lastName}`.trim();
  const email = userData?.email;
  const audience = audienceFromUser(userData);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, sm: 4 }, px: { xs: 2, sm: 3 } }}>
      <Paper
        elevation={0}
        variant="outlined"
        sx={{
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          bgcolor: 'background.paper',
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <CheckCircleIcon
            sx={{
              // intentional: registration milestone illustration (legacy layout)
              fontSize: 64,
              color: 'success.main',
              mb: 2,
            }}
          />
        </Box>

        <PendingApprovalPresentation
          audience={audience}
          mode="registrationPending"
          email={email}
          userName={userName || undefined}
          icon="none"
          titleVariant="h4"
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center',
            alignItems: 'stretch',
            gap: 2,
            mt: 4,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/')}
            sx={{
              minHeight: TOUCH.minSize,
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            Return to Home
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate('/contact')}
            sx={{
              minHeight: TOUCH.minSize,
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            Contact Support
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

RegistrationPendingApproval.propTypes = {
  userData: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    role: PropTypes.string,
    firm_id: PropTypes.string,
    approval_status: PropTypes.string,
  }),
};

RegistrationPendingApproval.defaultProps = {
  userData: null,
};

export default RegistrationPendingApproval;
